import {API, Endpoints} from "@brg/api";
import {useEffect, useState} from "react";

export interface ICourseGroupMember {
    designerId?: string;
    accountId?: string;
}

export interface ICourseGroup {
    id: string;
    name?: string;
    title?: string;
    members?: ICourseGroupMember[];
    teachers?: ICourseGroupMember[];
    teachersIDs?: string[];
    lmsGroupCuratorId?: string;
}

export const useGetGroupsInfoByCourseId = (teamId: string | undefined, lang: string, disabled?: boolean) => {
    const [groups, setGroups] = useState<ICourseGroup[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!teamId || disabled) {
            setGroups([]);
            return;
        }

        const abortController = new AbortController();

        setIsLoading(true);
        setError(false);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/LMS/GetGroupsInfoByCourseId')
            .addQuery('teamId', teamId)
            .get()
            .send({signal: abortController.signal})
            .then((r: any) => r.json())
            .then((r: any) => {
                setIsLoading(false)
                const list = Array.isArray(r?.groups) ? r.groups : [];
                setGroups(API.toLang(list, lang) as ICourseGroup[])
            })
            .catch((e: any) => {
                if (e?.name === 'AbortError') return;
                setIsLoading(false)
                setGroups([])
                setError(true)
            })

        return () => abortController.abort();
    }, [teamId, lang, disabled])

    return {groups, isLoading, error};
}
import {API, Endpoints} from "@brg/api";
import {useEffect, useState} from "react";

export interface ICourseGroupMember {
    designerId?: string;
    accountId?: string;
}

export interface ICourseGroup {
    id: string;
    name?: string;
    title?: string;
    members?: ICourseGroupMember[];
    teachers?: ICourseGroupMember[];
    teachersIDs?: string[];
    lmsGroupCuratorId?: string;
}

export const useGetGroupsInfoByCourseId = (teamId: string | undefined, lang: string, disabled?: boolean) => {
    const [groups, setGroups] = useState<ICourseGroup[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!teamId || disabled) {
            setGroups([]);
            return;
        }

        const abortController = new AbortController();

        setIsLoading(true);
        setError(false);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/LMS/GetGroupsInfoByCourseId')
            .addQuery('teamId', teamId)
            .get()
            .send({signal: abortController.signal})
            .then((r: any) => r.json())
            .then((r: any) => {
                setIsLoading(false)
                const list = Array.isArray(r?.groups) ? r.groups : [];
                setGroups(API.toLang(list, lang) as ICourseGroup[])
            })
            .catch((e: any) => {
                if (e?.name === 'AbortError') return;
                setIsLoading(false)
                setGroups([])
                setError(true)
            })

        return () => abortController.abort();
    }, [teamId, lang, disabled])

    return {groups, isLoading, error};
}
